import { render, staticRenderFns } from "./VlModalDisplayData.vue?vue&type=template&id=5b44009c&scoped=true&"
import script from "./VlModalDisplayData.vue?vue&type=script&lang=js&"
export * from "./VlModalDisplayData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44009c",
  null
  
)

export default component.exports